import axios from "./axios";

export const getFiles = (token, id = "") => {
  return axios.get("/vault/" + id, {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const addToArchive = (token, id, dates, provider = "xero") => {
  const isQbo = provider === "qbo";
  return axios.post(
    isQbo ? "/qbo/add-archived" : "/xero/add-archived",
    isQbo
      ? {
          backup_date: dates,
          qbo_id: id,
        }
      : {
          backup_date: dates,
          xero_id: id,
        },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const removeFromArchive = (token, id, dates, provider = "xero") => {
  const isQbo = provider === "qbo";
  return axios.post(
    isQbo ? "/qbo/remove-archived" : "/xero/remove-archived",
    isQbo
      ? {
          backup_date: dates,
          qbo_id: id,
        }
      : {
          backup_date: dates,
          xero_id: id,
        },
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};
export const getArchivedOrganizations = (token, provider = "xero") => {
  const isQbo = provider === "qbo";
  return axios.get(isQbo ? "/qbo/archived" : "/xero/archived", {
    headers: {
      "API-TOKEN": token,
    },
  });
};

export const getArchivedOrganizationFolders = (token, id = "", provider = "xero") => {
  const isQbo = provider === "qbo";
  return axios.get(isQbo ? `/qbo/${id}/archived` : `/xero/${id}/archived`, {
    headers: {
      "API-TOKEN": token,
    },
  });
};
